import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { number } from 'prop-types';

import styles from './styles/index';

export default class FakeLoadingBar extends React.Component {
  static propTypes = {
    loadTime: number
  };

  static defaultProps = {
    loadTime: 1000
  };

  state = {
    progress: 0
  };

  mounted = false; // eslint-disable-line

  componentDidMount() {
    this.mounted = true;

    const ticks = 30;

    this.interval = setInterval(() => {
      this.setState({
        // todo: use a nice interp fn
        progress: this.state.progress + 100 / ticks
      });
    }, this.props.loadTime / ticks);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <LinearProgress
        mode="determinate"
        value={this.state.progress}
        className={styles.loadingBar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/FakeLoadingBar/index.js